import { MenuDivider } from "@szhsin/react-menu";

import cn from "@utils/cn";

const CLASS_NAMES = cn(`
  block
  h-px
  m-0
  border-none

  bg-[#E5E5E5]
`);

export default function ActionMenuDividerItem(_props) {
  return (
    <MenuDivider>
      <hr className={CLASS_NAMES} />
    </MenuDivider>
  );
};
